import type { CheckoutTask } from "checkout/api/checkoutSteps";

function applyScheduleSiteSurveyUnlockForHqs(
  tasks: CheckoutTask[],
  isHqsEligible: boolean,
  isCustomerAgreementComplete: boolean
): CheckoutTask[] {
  if (isHqsEligible && isCustomerAgreementComplete) {
    return tasks.map((task) =>
      task.id === "scheduleSiteSurvey" ? { ...task, isUnlocked: true } : task
    );
  }

  return tasks;
}

export { applyScheduleSiteSurveyUnlockForHqs };
